








import { Component, Vue } from "vue-property-decorator";
import Servicios from "@/components/Servicios/Servicios.vue";

@Component({
  components: {
    Servicios
  },
  meta: {
    // sets document title
    title: "Servicios y Trámites - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí lasoServicios y Trámites disponibles para ti."
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class ServiciosView extends Vue {
  private mounted() {
    document.title =
      "Servicios y Trámites - Ilustre Municipalidad de Punta Arenas";
  }
}
